/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Meta_DescriptionInputs */

const en_home_meta_description = /** @type {(inputs: Home_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Launch your AI-powered storefront. Sell digital products, physical goods, and services with zero friction.`)
};

const es_home_meta_description = /** @type {(inputs: Home_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lanza tu tienda impulsada por IA. Vende productos digitales, bienes físicos y servicios sin fricciones.`)
};

const fr_home_meta_description = /** @type {(inputs: Home_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lancez votre vitrine propulsée par l'IA. Vendez des produits numériques, des biens physiques et des services sans friction.`)
};

const de_home_meta_description = /** @type {(inputs: Home_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starte deine KI-gestützte Storefront. Verkaufe digitale Produkte, physische Waren und Dienstleistungen ohne Reibungsverluste.`)
};

const ja_home_meta_description = /** @type {(inputs: Home_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AIを活用したストアフロントを立ち上げましょう。デジタル製品、物理的な商品、サービスを摩擦ゼロで販売できます。`)
};

const zh_home_meta_description = /** @type {(inputs: Home_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`启动您的 AI 驱动店铺。零摩擦地销售数字产品、实体商品和服务。`)
};

const ar_home_meta_description = /** @type {(inputs: Home_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أطلق واجهة متجرك المدعومة بالذكاء الاصطناعي. بِع المنتجات الرقمية والسلع المادية والخدمات بسهولة تامة.`)
};

const id_home_meta_description = /** @type {(inputs: Home_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luncurkan etalase berbasis AI Anda. Jual produk digital, barang fisik, dan layanan tanpa hambatan.`)
};

const it_home_meta_description = /** @type {(inputs: Home_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lancia la tua vetrina basata sull'IA. Vendi prodotti digitali, beni fisici e servizi senza alcun attrito.`)
};

const ru_home_meta_description = /** @type {(inputs: Home_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Запустите свою витрину на базе ИИ. Продавайте цифровые продукты, физические товары и услуги без проблем.`)
};

const pt_home_meta_description = /** @type {(inputs: Home_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lance sua vitrine com tecnologia de IA. Venda produtos digitais, bens físicos e serviços sem atritos.`)
};

const ko_home_meta_description = /** @type {(inputs: Home_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI 기반 스토어프론트를 런칭하세요. 디지털 제품, 실물 상품 및 서비스를 마찰 없이 판매하세요.`)
};

/**
* | output |
* | --- |
* | "Launch your AI-powered storefront. Sell digital products, physical goods, and services with zero friction." |
*
* @param {Home_Meta_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const home_meta_description = /** @type {((inputs?: Home_Meta_DescriptionInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Meta_DescriptionInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_home_meta_description(inputs)
	if (locale === "es") return es_home_meta_description(inputs)
	if (locale === "fr") return fr_home_meta_description(inputs)
	if (locale === "de") return de_home_meta_description(inputs)
	if (locale === "ja") return ja_home_meta_description(inputs)
	if (locale === "zh") return zh_home_meta_description(inputs)
	if (locale === "ar") return ar_home_meta_description(inputs)
	if (locale === "id") return id_home_meta_description(inputs)
	if (locale === "it") return it_home_meta_description(inputs)
	if (locale === "ru") return ru_home_meta_description(inputs)
	if (locale === "pt") return pt_home_meta_description(inputs)
	return ko_home_meta_description(inputs)
});